export default {"src":"/_next/static/media/instalmentPeriodFara.998095c3.svg","height":117,"width":1234};